export const TABS_LOG = {
    HISTORY_LOGIN: 'HISTORY_LOGIN',
    HISTORY_SYSTEM_LOGIN: 'HISTORY_SYSTEM_LOGIN',
    HISTORY_ERROR: 'HISTORY_ERROR',
    HISTORY_MANAGER_ACCOUNT: 'HISTORY_MANAGER_ACCOUNT',
    HISTORY_CONFIG_SYSTEM: 'HISTORY_CONFIG_SYSTEM',
    HISTORY_MANAGER_CTH: 'HISTORY_MANAGER_CTH',
    HISTORY_MFA: 'HISTORY_MFA'
}

export const MODULE_TABS_LOG = {
    SIP: 'sip',
    USER: 'user',
    CONFIG: 'config'
}

export const ROLE_TABS_LOG = {
    ADMIN: 'admin',
    GUEST: 'guest'
}

export const ARRAY_TABS_LOG = [
    "HISTORY_LOGIN",
    "HISTORY_SYSTEM_LOGIN",
    "HISTORY_ERROR",
    "HISTORY_MANAGER_ACCOUNT",
    "HISTORY_CONFIG_SYSTEM",
    "HISTORY_MANAGER_CTH",
    "HISTORY_MFA"
]